
































































import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import {ISelectOption as iso} from '@/class/models/typed/wild';
export type IOption = iso;
import * as models from '@/class/models/views/graph';
import ModalBase3 from '@/components/util/ModalBase3.vue';
import InfiniteLoading from 'vue-infinite-loading';
import API from '@/api/common';

// 第３次で追加
import {NOC, moment} from '@/class';
import SelectBox from '@/components/util/SelectBox.vue';
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

interface Data {
  myValues: models.IValues;
  items: any[];
  fields: any[];
  dl: boolean;
  selectMaxCount: number;
  nextPage: number;
  title: string;
  loading: boolean;
  downloading: boolean;
  ct1Options: IOption[];
  ct1Flag: boolean;
  ct1Ini: number;
  ct1Value: string;
}
interface Computed {
  isNoSelectUser: boolean;
  isDateError: boolean;
}
interface Props {
  values: models.IValues;
}

export default Vue.extend({
  name: 'ListDetailV3',
  components: { ModalBase3, InfiniteLoading, SelectBox, DatePicker },
  props: {
    values: Object as PropOptions<models.IValues>,
  },
  data() {
    return {
      myValues: {} as models.IValues,
      items: [] as any[],
      fields: [] as any[],
      dl: false,
      infiniteId: 0,
      selectMaxCount: 0,
      nextPage: 0,
      title: '',
      loading: true,
      downloading: false,
      ct1Options: [NOC.SELECT.NOSELECT] as IOption[],
      ct1Flag: false,
      ct1Ini: -1,
      ct1Value: '',
      DatePickerDate: 'yyyy. MM. dd',
      ja,
    };
  },
  computed: {
    isNoSelectUser() {
      return Number(this.ct1Value) <= NOC.SELECT.NOSELECT.value;
    },
    isDateError() {
      return !this.myValues.dateto || new Date(this.myValues.date) > new Date(this.myValues.dateto);
    },
  },
  async mounted() {
    this.myValues = this.values;
    this.dl = false;
    const api = new API();
    const res = await api.post<any, IOption[]>('gadget/ct1', NOC.GRAPH.MATERIAL.V2.MATERIAL[0]);
    if (res.result) {
      if (res.data.length > 0) {
        this.ct1Options = this.ct1Options.concat(res.data);
        this.ct1Flag = true;
      }
    }
    if (!this.myValues.dateto) {
      const resTerm = await api.post<models.IValues, models.IValues>('gadget/term', this.values);
      if (resTerm.result) {
        this.myValues = resTerm.data;
      }
    }
    this.ct1Ini = Number(this.myValues.setData);
    this.loading = false; // infiniteLoading開始
  },
  methods: {
    async infiniteHandler($state: any) {
      // 無限ローディング対策
      if (!this.loading) {
        this.loading = true;
        const api = new API();
        const requestData = {
          values: this.myValues,
          page: this.nextPage,
        };

        // console.log('oi', requestData);
        const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);

        if (res.result) {
          if (this.nextPage === 0) {
            this.dl = true;
            this.fields = res.data.fileds;
            this.title = res.data.title;
          }
          this.items = this.items.concat(res.data.items);
          this.selectMaxCount = res.data.count;

          // console.log(res.data.count);
          if (this.items.length < this.selectMaxCount) {
          // if (false) {
            $state.loaded();
          } else {
            $state.complete();
          }
          this.nextPage++;
        }
        this.loading = false;
      }
    },
    async onClickDownLoad() {
      if (this.downloading) {
        return;
      }
      this.downloading = true;
      const api = new API();
      const requestData = {
        values: this.myValues,
        page: 0,
        csv: true,
      };
      const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);
      this.downloading = false;
      if (res.result) {
        // console.log(res.data);
      }
    },
    async detailAction() {
      if (this.isNoSelectUser || this.isDateError) { // ユーザー名や日付に不備があるときは何もしない
        return;
      }
      this.myValues = {
        setData: this.ct1Value,
        date: moment.fncChangeDateToInputForm(new Date(this.myValues.date)),
        dateto: moment.fncChangeDateToInputForm(new Date(this.myValues.dateto || this.myValues.date)),
      } as models.IValues;
      // リセット
      this.dl = false;
      this.nextPage = 0;
      this.items = [];
      // 再ロード
      (this.$refs.infiniteLoading as any).stateChanger.reset();
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, {}, Computed, Props>);
